// The checkpoints below are send to BE whenever:
//
// A) The current step increases
// B) A document is scanned
//
// In case the user informs of an error, these checkpoints help keep track
// of the step in which the user is stuck
import { DOCUMENT_TYPE } from './docs.const';

export const API_CHECKPOINTS = {
  newWorkflow: {
    checkpoint: 100,
    freeText: 'NEW_WORKFLOW',
  },

  disclaimerAccepted: {
    checkpoint: 120,
    freeText: 'DISCLAIMER_ACCEPT',
  },

  countryChanged: {
    checkpoint: 150,
    freeText: 'COUNTRY_CHANGED',
  },

  selectDocuments: {
    checkpoint: 200,
    freeText: 'REQUIRED_DOCS_INIT',
  },

  documentsToValidate: {
    checkpoint: 220,
    freeText: 'REQUIRED_DOCS_START_SCAN:',
  },

  driverLicenseScan: {
    start: {
      checkpoint: 320,
      freeText: 'ONFIDO_DL_START',
    },

    completed: {
      checkpoint: 330,
      freeText: 'ONFIDO_DL_SCAN_OK',
    },
  },

  idScan: {
    start: {
      checkpoint: 420,
      freeText: 'ONFIDO_ID_START',
    },

    completed: {
      checkpoint: 430,
      freeText: 'ONFIDO_ID_SCAN_OK',
    },
  },

  passportScan: {
    start: {
      checkpoint: 520,
      freeText: 'ONFIDO_PASSPORT_START',
    },

    completed: {
      checkpoint: 530,
      freeText: 'ONFIDO_PASSPORT_SCAN_OK',
    },
  },

  summaryInit: {
    checkpoint: 600,
    freeText: 'SUMMARY_INIT',
  },

  summaryEnd: {
    checkpoint: 630,
    freeText: 'SUMMARY_END_WORKFLOW',
  },

  updateAddress: {
    checkpoint: 700,
    freeText: 'ADDRESS_UPDATE_INIT',
  },

  onfidoError: {
    checkpoint: 900,
    freeText: '',
  },

  validationError: {
    checkpoint: 909,
    freeText: '',
  },

  processCompleted: {
    checkpoint: 910,
    freeText: 'SCAN_PROCESS_FINISHED_OK',
  },

  processError: {
    checkpoint: 911,
    freeText: 'SCAN_PROCESS_ERROR',
  },
} as const;

export const ONFIDO_DOCUMENT_CHECKPOINTS = {
  [DOCUMENT_TYPE.onfido.drivingLicense]: API_CHECKPOINTS.driverLicenseScan,
  [DOCUMENT_TYPE.onfido.nif]: API_CHECKPOINTS.idScan,
  [DOCUMENT_TYPE.onfido.passport]: API_CHECKPOINTS.passportScan,
} as const;
